'use strict';

import '../css/style.css';

document.addEventListener('DOMContentLoaded', () => {
  window.isDark = false;

  const mediaQuery     = matchMedia('(prefers-color-scheme: dark)');
  const updateDarkMode = () => {
    window.isDark = mediaQuery.matches;
  };

  updateDarkMode();

  addEventListener('change', updateDarkMode);

  const dynamicBackgroundCanvas = document.querySelector('canvas.background');

  if ( dynamicBackgroundCanvas ) {
    const context    = dynamicBackgroundCanvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio || 1;
    const width      = window.innerWidth;
    const height     = window.innerHeight;
    let angle        = 90,
        radius       = 0,
        u            = Math.PI * 2,
        q;

    dynamicBackgroundCanvas.width  = width * pixelRatio;
    dynamicBackgroundCanvas.height = height * pixelRatio;
    context.scale(pixelRatio, pixelRatio);
    context.globalAlpha = 0.6;

    function render () {
      context.clearRect(0, 0, width, height);
      q = [
        { x: 0, y: height * .7 + angle },
        { x: 0, y: height * .7 - angle },
      ];

      while ( q[ 1 ].x < width + angle ) {
        frame(q[ 0 ], q[ 1 ]);
      }
    }

    function frame ( i, j ) {
      context.beginPath();
      context.moveTo(i.x, i.y);
      context.lineTo(j.x, j.y);

      let k = j.x + ( Math.random() * 2 - 0.25 ) * angle,
          n = y(j.y);

      context.lineTo(k, n);
      context.closePath();

      radius -= u / -50;

      context.fillStyle = '#' +
        ( Math.cos(radius) *
          127 +
          128 <<
          16 |
          Math.cos(radius + u / 3) *
          127 +
          128 <<
          8 |
          Math.cos(radius + u / 3 * 2) *
          127 +
          128 ).toString(16);
      context.fill();
      q[ 0 ] = q[ 1 ];
      q[ 1 ] = { x: k, y: n };
    }

    function y ( p ) {
      let t = p + ( Math.random() * 2 - 1.1 ) * angle;

      return ( t > height || t < 0 ) ? y(p) : t;
    }

    render();
  }
});

( function ( w, d, s, l, i ) {
  w[ l ] = w[ l ] || [];
  w[ l ].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  let f   = d.getElementsByTagName(s)[ 0 ], j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src   = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
} )(window, document, 'script', 'dataLayer', 'GTM-TZJ282M');
